import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';
// import { MsAdalAngular6Module } from 'microsoft-adal-angular6'; // Deprecated - using MSAL v3 instead
import { AppConstant } from './app.constant';

@Injectable({
  providedIn: 'root'
})
export class AuthguardService implements CanActivate {

  constructor(
    // private adalservice: MsAdalAngular6Module,
    private router: Router
  ) { }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    let url: string = state.url;
    console.log(url);
    if(!localStorage.getItem(AppConstant.localStorage.token)){
      this.router.navigateByUrl("");
      return false;
    }
    return true;
  }
}
